import React from "react";
import { labelDimensions } from "../../misc/constants";

const { width, height } = labelDimensions;

const Canvasses = () => (
  <div style={{ position: "absolute", left: -9999, display: "none" }}>
    {/* Do not add glamourous to any <canvas>. It breaks toDataURL() */}
    <canvas id="canvas1" width={width} height={height} />
    {/* Some operations require a second <canvas> */}
    <canvas id="canvas2" width={width} height={height} />
  </div>
);

export default Canvasses;



// WEBPACK FOOTER //
// ./src/components/common/Canvasses.js